import { render, staticRenderFns } from "./WhitelistFreeTypes.vue?vue&type=template&id=8fbb570c"
import script from "./WhitelistFreeTypes.vue?vue&type=script&lang=js"
export * from "./WhitelistFreeTypes.vue?vue&type=script&lang=js"
import style0 from "./WhitelistFreeTypes.vue?vue&type=style&index=0&id=8fbb570c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports